import React from 'react';
import classNames from 'classnames';

// 디자이너 도구 모음 행 — 최상단 AppHeader(50px) 아래의 보조 행이라 더 낮게
const HEADER_HEIGHT_CLASS = 'h-10';

interface HeaderProps {
  headerStart?: React.ReactNode;
  headerMiddle?: React.ReactNode;
  headerEnd?: React.ReactNode;
  className?: string;
  container?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  headerStart,
  headerEnd,
  headerMiddle,
  className,
  container,
}) => {
  return (
    <header className={classNames('header bg-gray-50 border-b border-gray-200', className)}>
      <div
        className={classNames(
          'header-wrapper flex items-center justify-between px-4',
          HEADER_HEIGHT_CLASS,
          container && 'container mx-auto'
        )}
      >
        <div className="header-action header-action-start">
          {headerStart}
        </div>
        {headerMiddle && (
          <div className="header-action header-action-middle">
            {headerMiddle}
          </div>
        )}
        <div className="header-action header-action-end">
          {headerEnd}
        </div>
      </div>
    </header>
  );
};

export default Header; 